import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ImportComponent } from '../import/import/import.component';
import { ImportFormat } from 'src/app/models/importFormat';

@Injectable({
  providedIn: 'root'
})
export class ImportControlService {

  constructor(private modalService: BsModalService) { }

  showMesssageModal(entity: string, fileFormats: ImportFormat[]) {
    const bsModalRef: BsModalRef = this.modalService.show(ImportComponent);
    bsModalRef.content.entity = entity;
    bsModalRef.content.formatsToDisplay = fileFormats;
  }
}
